import { setDeliveryErrors } from "../../store/slices/errors";
import masivos_mock from "../../mock-data/masivosMock/masivos_mock.json";
import apiClient from "../../utils/api.client";
import { getNoaId } from "../../utils/session.utils";

const getDeliveryNote = async (pageNumber, pageSize, dispatch, sort) => {
  try {
    const { criteria, field } = sort;
    const url = `/delivery-service/deliverynote?organizationId=${getNoaId()}&pageNumber=${pageNumber || 1}&pageSize=${pageSize || 10}&orderCriteria=${criteria || "DESC"}&orderField=${field || "date"}`;
    const response = await apiClient.get(url);
    const data = response.data;
    dispatch(setDeliveryErrors({ error: false }));

    return data;
  } catch (error) {
    console.error("Error at getDeliveryNote EP: ", error);
    throw error;
  }
};

const editDeliveryNote = async (payload) => {
  try {
    const url = `/delivery-service/deliverynote`;
    const response = await apiClient.put(url, payload);
    const data = response.data;

    console.log("From editDeliveryNote: ", data);

    return data;
  } catch (error) {
    console.error("Error at editDeliveryNote EP: ", error);
    throw error;
  }
};

const createDeliveryNote = async (payload) => {
  try {
    const url = `/delivery-service/deliverynote`;
    console.log("🔍 [DeliveryService] Creando remito manualmente");
    console.log("🔍 [DeliveryService] URL:", url);
    console.log("🔍 [DeliveryService] Payload completo:", JSON.stringify(payload, null, 2));
    const response = await apiClient.post(url, payload);
    const data = response.data;
    console.log("✅ [DeliveryService] Remito creado:", JSON.stringify(data, null, 2));
    return data;
  } catch (error) {
    console.error("❌ [DeliveryService] Error at createDeliveryNote EP:", error);
    throw error;
  }
};

const getDeliveryNoteById = async (id) => {
  try {
    const url = `/delivery-service/deliverynote/${id}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getDeliveryNoteById EP: ", error);
    throw error;
  }
};

const deleteDeliveryNoteById = async (id) => {
  // return fetch(`${getServiceUrl()}/deliverynote/${id}`, {
  //   method: "DELETE",
  //   headers: { "Content-Type": "application/json" }
  // }).then(res => {
  //   if (res.status === 200) {
  //     return res.json();
  //   } else {
  //     throw { res, isServiceException: true }
  //   }
  // })
  //   .catch(async (e) => {
  //     if (!e.isServiceException) {
  //       throw e
  //     } else {
  //       const res = await e.res.json();
  //       throw { ...res, isServiceException: true }
  //     }
  //   })

  try {
    const url = `/delivery-service/deliverynote/${id}`;
    const response = await apiClient.delete(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at deleteDeliveryNoteById EP: ", error);
    throw error;
  }
};

const searchDeliveryNotes = async (page, pageSize, filters, sort) => {
  // const { criteria, field } = sort;
  //
  // let dateFilter = filters?.dateRemit?.split('T')[0]?.split('-').reverse().join('-');
  // let url = `${getServiceUrl()}/deliverynote/search?pageNumber=${page}&pageSize=${pageSize}&orderCriteria=${criteria || 'DESC'}&orderField=${field || 'date'}${filters.number !== 0 ? `&number=${filters.number}` : ''}${filters.dateRemit !== null ? `&date=${dateFilter}` : ''}${filters.type !== 'any' ? `&type=${filters.type}` : ''}${filters.state !== 'any' ? `&state=${filters.state}` : ''}${filters.provider !== 'all' ? `&supplierId=${filters.provider}` : ''}${filters.agency !== 'all' ? `&agencyId=${filters.agency}` : ''}${filters.orderID !== 0 ? `&orderID=${filters.orderID}` : ''}`
  // return fetch(url, {
  //   method: "GET",
  //   headers: { "Content-Type": "application/json", "accept": "application/json" }
  // })
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.json();
  //     } else {
  //       throw { res, isServiceException: true }
  //     }
  //   })
  //   .catch(async (e) => {
  //     if (!e.isServiceException) {
  //       throw e
  //     } else {
  //       const res = await e.res.json();
  //       throw { ...res, isServiceException: true }
  //     }
  //   })

  try {
    const { criteria, field } = sort;
    let dateFilter = filters?.dateRemit
      ?.split("T")[0]
      ?.split("-")
      .reverse()
      .join("-");
    const url = `/delivery-service/deliverynote/search?pageNumber=${page}&pageSize=${pageSize}&orderCriteria=${criteria || "DESC"}&orderField=${field || "date"}${filters.number !== 0 ? `&number=${filters.number}` : ""}${filters.dateRemit !== null ? `&date=${dateFilter}` : ""}${filters.type !== "any" ? `&type=${filters.type}` : ""}${filters.state !== "any" ? `&state=${filters.state}` : ""}${filters.provider !== "all" ? `&supplierId=${filters.provider}` : ""}${filters.agency !== "all" ? `&agencyId=${filters.agency}` : ""}${filters.orderID !== 0 ? `&orderID=${filters.orderID}` : ""}`;
    const response = await apiClient.get(url);
    const data = response;

    return data;
  } catch (error) {
    console.error("Error at searchDeliveryNotes EP: ", error);
    throw error;
  }
};

const getSequency = async () => {
  try {
    const url = `/delivery-service/deliverynote/sequence`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getSequency EP: ", error);
    throw error;
  }
};

// WARNING: Figure out the use of this
const getMasivosMock = async () => {
  return new Promise((res) => res(masivos_mock))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        throw { res, isServiceException: true };
      }
    })
    .catch(async (e) => {
      if (!e.isServiceException) {
        throw e;
      } else {
        const res = await e.res.json();
        throw { ...res, isServiceException: true };
      }
    });
};

const getProductsByAgencyNumber = async (agencyNumber, page) => {
  // let url = `${getServiceUrl()}/coupon/movements/byAgency/${agencyNumber}?pageNumber=${page || 1}&pageSize=10&orderCriteria=DESC&orderField=creationDate`
  // return fetch(url, {
  //   method: "GET",
  //   headers: { "Content-Type": "application/json", "accept": "application/json" }
  // })
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.json();
  //     } else {
  //       throw { res, isServiceException: true }
  //     }
  //   })
  //   .catch(async (e) => {
  //     if (!e.isServiceException) {
  //       throw e
  //     } else {
  //       const res = await e.res.json();
  //       throw { ...res, isServiceException: true }
  //     }
  //   })

  try {
    let url = `/delivery-service/coupon/movements/byAgency/${agencyNumber}?pageNumber=${page || 1}&pageSize=10&orderCriteria=DESC&orderField=creationDate`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getProductsByAgencyNumber EP: ", error);
    throw error;
  }
};

const getProductsByAgencyId = async (agencyId, page, gameId) => {
  // let url = `${getServiceUrl()}/coupon/movements/byAgencyId/${agencyId}?pageNumber=${page || 1}&pageSize=10&orderCriteria=DESC&orderField=creationDate${gameId !== null ? `&gameId=${gameId}` : ''}`
  // return fetch(url, {
  //   method: "GET",
  //   headers: { "Content-Type": "application/json", "accept": "application/json" }
  // })
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.json();
  //     } else {
  //       throw { res, isServiceException: true }
  //     }
  //   })
  //   .catch(async (e) => {
  //     if (!e.isServiceException) {
  //       throw e
  //     } else {
  //       const res = await e.res.json();
  //       throw { ...res, isServiceException: true }
  //     }
  //   })

  try {
    let url = `/delivery-service/coupon/movements/byAgencyId/${agencyId}?pageNumber=${page || 1}&pageSize=10&orderCriteria=DESC&orderField=creationDate${gameId !== null ? `&gameId=${gameId}` : ""}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getProductsByAgencyId EP: ", error);
    throw error;
  }
};

const getProductsBySupplierId = async (supplierId, page) => {
  // let url = `${getServiceUrl()}/coupon/movements/bySupplier/${supplierId}?pageNumber=${page || 1}&pageSize=10&orderCriteria=DESC&orderField=creationDate`
  // return fetch(url, {
  //   method: "GET",
  //   headers: { "Content-Type": "application/json", "accept": "application/json" }
  // })
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.json();
  //     } else {
  //       throw { res, isServiceException: true }
  //     }
  //   })
  //   .catch(async (e) => {
  //     if (!e.isServiceException) {
  //       throw e
  //     } else {
  //       const res = await e.res.json();
  //       throw { ...res, isServiceException: true }
  //     }
  //   })
  try {
    let url = `/delivery-service/coupon/movements/bySupplier/${supplierId}?pageNumber=${page || 1}&pageSize=10&orderCriteria=DESC&orderField=creationDate`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getProductsBySupplierId EP: ", error);
    throw error;
  }
};

const getDeliveryNoteByOrderId = async (orderId) => {
  try {
    let url = `/delivery-service/deliverynote/by-order/${orderId || -1}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getDeliveryNoteByOrderId EP: ", error);
    throw error;
  }
};

const getNoaOrganization = async (organizationId) => {
  try {
    const response = await apiClient.get(
      `/delivery-service/organization/${organizationId}`,
    );
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getNoaOrganization", error);
    throw error;
  }
};

const concilitation = async (fileId) => {
  try {
    const response = await apiClient.put(
      `/delivery-service/files/vta/conciliate/${fileId}`,
    );
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at conciliation ep", error);
    throw error;
  }
};

const deliveryServices = {
  getDeliveryNote,
  editDeliveryNote,
  createDeliveryNote,
  getDeliveryNoteById,
  deleteDeliveryNoteById,
  searchDeliveryNotes,
  getSequency,
  getMasivosMock,
  getProductsByAgencyNumber,
  getProductsByAgencyId,
  getProductsBySupplierId,
  getDeliveryNoteByOrderId,
  getNoaOrganization,
  concilitation,
};


export default deliveryServices;
